export const API_URL_ONBOARDING_SET_SUBSCRIPTION_DETAILS = "/shop/api/onboarding/setsubscriptiondetails";
export const API_URL_ONBOARDING_SUBMIT_ORDER = "/shop/api/onboarding/submitorder";
export const API_URL_ONBOARDING_VERIFY_UPDATED_NAME = "/shop/api/onboarding/verifyupdatedname";
